// Mock data for Tecno Domus 360 website

export const companyInfo = {
  name: "Tecno Domus 360 di De Cupis Roberto",
  slogan: "Ristrutturazioni e impianti elettrici affidabili, realizzati con professionalità e attenzione al cliente a Roma e provincia.",
  area: "Roma e provincia",
  email: "info@tecnodomus360.it",
  phone: "+39 328 8487837"
};

export const services = [
  {
    id: 1,
    title: "Ristrutturazioni Civili Complete",
    description: "Progettazione e realizzazione di interventi di ristrutturazione completi per abitazioni e uffici, con attenzione ai dettagli e rispetto delle tempistiche.",
    icon: "Home"
  },
  {
    id: 2,
    title: "Impianti Elettrici Civili e Industriali",
    description: "Progettazione, installazione e manutenzione di impianti elettrici conformi alle normative vigenti, per ogni tipologia di edificio.",
    icon: "Zap"
  },
  {
    id: 3,
    title: "Impianti di Allarme e Sicurezza",
    description: "Sistemi di sicurezza integrati per proteggere la tua casa o azienda, con tecnologie all'avanguardia e assistenza garantita.",
    icon: "Shield"
  },
  {
    id: 4,
    title: "Automazioni e Domotica",
    description: "Soluzioni smart per il controllo intelligente degli impianti domestici e aziendali, per comfort ed efficienza energetica.",
    icon: "Smartphone"
  },
  {
    id: 5,
    title: "Pittura e Finiture",
    description: "Lavori di tinteggiatura e finiture collegate agli interventi elettrici e di ristrutturazione, per un risultato completo e curato.",
    icon: "Paintbrush"
  },
  {
    id: 6,
    title: "Certificazioni e Conformità",
    description: "Rilascio di dichiarazioni di conformità e documentazione tecnica necessaria secondo il D.M. 37/08.",
    icon: "FileCheck"
  }
];

export const certifications = [
  {
    title: "D.M. 37/08",
    description: "Impresa abilitata ai sensi del Decreto Ministeriale 37/08 (ex Legge 46/90)"
  },
  {
    title: "Dichiarazioni di Conformità",
    description: "Abilitazione al rilascio di Dichiarazioni di Conformità per tutti gli impianti realizzati"
  },
  {
    title: "Categorie A, B, C",
    description: "Certificazione per impianti elettrici di diverse categorie e complessità"
  }
];

export const galleryImages = {
  "Bagni & Cucine": [
    {
      id: 101,
      url: require('./assets/images/Bagni & Cucine/Cucina loft.jpg'),
      title: "Cucina Loft",
      subtitle: "Design Moderno"
    },
    {
      id: 102,
      url: require('./assets/images/Bagni & Cucine/bagno bosco.jpg'),
      title: "Bagno Bosco",
      subtitle: "Stile Naturale"
    },
    {
      id: 1,
      url: require('./assets/images/Bagni & Cucine/cucina_parquet_luci_retouched_1771095175880.png'),
      title: "Illuminazione Cucina",
      subtitle: "Atmosfera Accogliente"
    },
    {
      id: 2,
      url: require('./assets/images/Bagni & Cucine/dettaglio_lavello_retouched_1771095415609.png'),
      title: "Dettaglio Lavello Moderno",
      subtitle: "Eleganza e Funzionalità"
    },
    {
      id: 3,
      url: require('./assets/images/Bagni & Cucine/cucina-parquet-moderno_retouched.png'),
      title: "Cucina con Parquet",
      subtitle: "Calore e Design"
    },
    {
      id: 4,
      url: require('./assets/images/Bagni & Cucine/bagno-2_retouched.png'),
      title: "Bagno Minimalista",
      subtitle: "Linee Pure"
    },
    {
      id: 5,
      url: require('./assets/images/Bagni & Cucine/bagno_1_retouched_1771095193996.png'),
      title: "Bagno Padronale",
      subtitle: "Comfort Esclusivo"
    }
  ],
  "Lighting": [
    {
      id: 6,
      url: require('./assets/images/Lighting/living-con-applique_retouched.png'),
      title: "Living Atmosphere",
      subtitle: "Relax e Luce"
    },
    {
      id: 7,
      url: require('./assets/images/Lighting/scala-con-led_retouched.png'),
      title: "Illuminazione Scala",
      subtitle: "Sicurezza e Stile"
    },
    {
      id: 8,
      url: require('./assets/images/Lighting/cucina-led.jpg'),
      title: "LED Sottopensile",
      subtitle: "Luce Funzionale"
    },
    {
      id: 9,
      url: require('./assets/images/Lighting/cornice-led_retouched.png'),
      title: "Cornici LED",
      subtitle: "Dettagli Architetturali"
    },
    {
      id: 10,
      url: require('./assets/images/Lighting/parete-divisoria_retouched.png'),
      title: "Parete Luminosa",
      subtitle: "Divisione Spazi"
    }
  ],
  "Restyling appartamenti": [
    {
      id: 111,
      url: require('./assets/images/Restyling appartamenti/Contrasto materico.jpg'),
      title: "Contrasto Materico",
      subtitle: "Dettagli Architettonici"
    },
    {
      id: 112,
      url: require('./assets/images/Restyling appartamenti/Minimalismo storico.jpg'),
      title: "Minimalismo Storico",
      subtitle: "Eleganza Classica"
    },
    {
      id: 11,
      url: require('./assets/images/Restyling appartamenti/loft-industriale.jpg'),
      title: "Loft Industriale",
      subtitle: "Recupero Spazi"
    },
    {
      id: 12,
      url: require('./assets/images/Restyling appartamenti/salotto.jpg'),
      title: "Living Moderno",
      subtitle: "Nuova Vita"
    },
    {
      id: 14,
      url: require('./assets/images/Restyling appartamenti/camino-con-tv_retouched.png'),
      title: "Area Camino",
      subtitle: "Focus Point"
    },
    {
      id: 15,
      url: require('./assets/images/Restyling appartamenti/dettaglio-muro_retouched.png'),
      title: "Texture Pareti",
      subtitle: "Finiture Materiche"
    },
    {
      id: 16,
      url: require('./assets/images/Restyling appartamenti/restyiling-tetto-antico_retouched.png'),
      title: "Recupero Travi",
      subtitle: "Fascino Antico"
    }
  ],
  "Spazi commerciali & uffici": [
    {
      id: 17,
      url: require('./assets/images/Spazi commerciali & uffici/sala-chiesa_retouched.png'),
      title: "Illuminazione Sacra",
      subtitle: "Valorizzazione Artistica"
    },
    {
      id: 18,
      url: require('./assets/images/Spazi commerciali & uffici/uffici-openspace.jpg'),
      title: "Open Space",
      subtitle: "Collaborazione"
    }
  ],
  "Automazione": [
    {
      id: 19,
      url: require('./assets/images/Automation/smart-control-panel.png'),
      title: "Pannello Smart Home",
      subtitle: "Controllo Centralizzato"
    },
    {
      id: 20,
      url: require('./assets/images/Automation/smart-hallway-lighting.png'),
      title: "Illuminazione Intelligente",
      subtitle: "Efficienza Energetica"
    },
    {
      id: 21,
      url: require('./assets/images/Automation/smart-kitchen-automation.png'),
      title: "Cucina Domotica",
      subtitle: "Comfort Avanzato"
    }
  ]
};

export const aboutText = {
  title: "Chi Siamo",
  content: [
    "Tecno Domus 360 di De Cupis Roberto è un'impresa artigiana con sede a Roma, specializzata in ristrutturazioni e impianti elettrici per clienti privati e aziende.",
    "Con anni di esperienza nel settore, Roberto De Cupis guida personalmente ogni progetto, garantendo un rapporto diretto con il cliente e un'attenzione costante alla qualità del lavoro.",
    "La nostra filosofia si basa su tre pilastri fondamentali: professionalità tecnica, trasparenza nei rapporti e affidabilità nell'esecuzione. Seguiamo ogni cliente dalla progettazione alla consegna finale, assicurando interventi conformi alle normative e realizzati a regola d'arte.",
    "Siamo una piccola impresa che fa della vicinanza al cliente il suo punto di forza, offrendo soluzioni personalizzate e un servizio completo che va dall'impianto elettrico alle finiture."
  ]
};

import { supabase } from './lib/supabase';

// Mock function for form submission - now integrated with Supabase
export const submitContactForm = async (formData) => {
  if (!supabase) {
    console.warn('Supabase not configured. Form submission ignored.');
    return { success: false, message: 'Database non configurato correttamente.' };
  }
  try {
    const { data, error } = await supabase
      .from('contact_submissions')
      .insert([
        {
          first_name: formData.firstName,
          last_name: formData.lastName,
          email: formData.email,
          phone: formData.phone || null,
          service_type: formData.serviceType || null,
          message: formData.message
        }
      ]);

    if (error) {
      console.error('Supabase error:', error);
      return { success: false, message: `Errore database: ${error.message}` };
    }

    // Trigger email notification via backend
    try {
      // In production (Vercel), the backend might be on a different URL or the same domain /api
      // For now, we try a relative call which is standard in many SPA/Backend setups
      fetch('/api/send-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      }).then(async res => {
        if (!res.ok) {
          const errorData = await res.json().catch(() => ({}));
          console.error('Backend email trigger failed:', res.status, errorData.message || 'Unknown error');
        } else {
          console.log('Backend email trigger success');
        }
      }).catch(err => console.error('Backend email trigger failed:', err));
    } catch (err) {
      console.error('Email trigger error:', err);
    }

    return { success: true, message: 'Richiesta inviata con successo!' };
  } catch (err) {
    console.error('Submission error:', err);
    return { success: false, message: 'Errore di connessione al database.' };
  }
};
